import { QuoteServiceApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SaveItemsAction } from '../context/SmartSendContextModels';
import { ApplierOption } from './ApplierOption';
import { RemoveOffset } from './DateHelper';

export function SmartSendSingleActionApplier(item: SmartSendItemApiModel, action: SaveItemsAction): string[] {
  const amended = [];

  const actions = action.payload.actions || [];
  const canApply = (x: ApplierOption) => actions.includes(x) && !!action.payload.changes[x];

  if (canApply('Meta')) {
    amended.push('Meta');
    for (const p in action.payload.changes.Meta) {
      item.Meta[p] = action.payload.changes.Meta[p];
    }
  }

  if (canApply('Dimensions')) {
    amended.push('Dimensions');
    item.PackageDimensions = action.payload.changes.Dimensions;
  }

  if (actions.includes('Consignment')) {
    amended.push('Consignment');
    item.Consignment = action.payload.changes.Consignment;
  }

  if (canApply('Sender')) {
    amended.push('Sender');
    amended.push('Tags');
    item.Sender = action.payload.changes.Sender;
  }

  if (canApply('Recipient')) {
    amended.push('Recipient');
    item.Recipient = action.payload.changes.Recipient;
  }

  if (canApply('Service')) {
    amended.push('Service');
    const s = action.payload.changes.Service as QuoteServiceApiModel;

    item.Service = {
      Name: s.Name,
      Id: s.Id,
      Provider: s.Provider,
      AccountId: s.AccountId,
      Meta: null
    };
  }

  if (canApply('MarketplaceOrderLines')) {
    amended.push('MarketplaceOrderLines');
    item.MarketplaceOrderLines = action.payload.changes.MarketplaceOrderLines;
  }

  if (canApply('Extras') || canApply('Protection')) {
    amended.push('Extras');
    item.Extras = action.payload.changes.Extras;
  }

  if (canApply('PreferredCollectionDate')) {
    amended.push('PreferredCollectionDate');
    item.PreferredCollectionDate = RemoveOffset(action.payload.changes.PreferredCollectionDate as Date);
  }

  if (canApply('ServiceOption')) {
    if (action.payload.changes.ServiceOption.Extras) {
      amended.push('ServiceOption');
      item.Extras = action.payload.changes.ServiceOption.Extras.map((e) => {
        return { Id: e.Id, Name: e.Name, Provider: e.Provider };
      });
    }
  }
  return amended;
}
